
<div class="scheduled-report-form px-4" data-app="true">
    <div :style="scheduledReportBanner.isShow ? 'bottom: 0;' : 'bottom: -10rem;'" :class="scheduledReportBanner.class"
        class="report-banner" style="z-index: 51;">
        <div class="d-flex align-items-center"><b>{{ scheduledReportBanner.text }}</b></div>
    </div>
    <div class="mt-3">
        <div class="navigation-header">
            <div class="header d-flex w-100 align-items-center py-2">
                <a :href="prevUrl" class="mr-3" @click.prevent="handleExit">
                    <v-icon dense color="#3F3F3F" size="24">mdi-arrow-left</v-icon>
                </a>
                <h3 class="m-0 p-0 m-0 title-header">
                    <span class="text-capitalize"><b>{{ pageTitle }}</b></span>
                </h3>
            </div>
            <span class="sub-header d-block my-2">
                Automated reports will be sent to the specified email address based on the schedule set below.
            </span>
        </div>
    </div>

    <!-- Stepper Header -->
    <StepperHeader :steps="steps" :currentStep="currentStep" />

    <!-- Step Contents & button stepper -->
    <div class="step-content py-3">
        <!-- Step 1: Report Template & Schedule -->
        <div v-show="currentStep === 1">
            <ReportTemplate ref="reportTemplateStep" @update:formData="handleFormDataUpdate"
                :initial-data="isEditMode ? initialData : null" @run-report="handleRunReport" />
            <StepperNextPrevButton :prevButtonLabel="labelPrevBtn" :nextButtonLabel="labelNextBtn"
                :currentStep="currentStep" :totalSteps="steps.length" :disableNextButton="isStep1NextDisabled"
                @next="nextStep" @prev="prevStep"
                :sticky="true"
                buttonLayoutPlacement="between" />
        </div>

        <!-- Step 2: Email Settings -->
        <div v-show="currentStep === 2">
            <EmailSetting ref="emailSettingStep" v-model="scheduledReportPayload.email_settings"
                :report-data="scheduledReportPayload" />
            <StepperNextPrevButton :prevButtonLabel="labelPrevBtn" :nextButtonLabel="labelNextBtn"
                :currentStep="currentStep" :totalSteps="steps.length" :disableNextButton="isStep2NextDisabled"
                @next="nextStep" @prev="prevStep"
                :sticky="true"
                buttonLayoutPlacement="between" />
        </div>

        <!-- Step 3: Preview -->
        <div v-show="currentStep === 3" class="step-content">
            <PreviewStep :report-data="scheduledReportPayload" />
            <div class="mt-4">
                <StepperNextPrevButton :prevButtonLabel="labelPrevBtn" :nextButtonLabel="submitButtonLabel"
                    :currentStep="currentStep" :totalSteps="steps.length" :disableNextButton="isStep3NextDisabled"
                    @next="nextStep" @prev="prevStep"
                    :sticky="true"
                    buttonLayoutPlacement="between" />
            </div>
        </div>
    </div>

    <v-dialog v-model="unsavedModal.isOpen" max-width="616px" persistent>
        <v-card class="bg-white p-4">
            <h4 style="font-size: 24px; color: #3F3F3F;">Unsaved Changes</h4>
            <p class="m-0 my-4" style="font-size: 14px; color: #3F3F3F;">
                Looks like you’ve made changes. Are you sure you want to leave this page?
                <br>
                If you leave, the updates you’ve made will be lost.
            </p>
            <div class="d-flex justify-content-between align-items-center" style="gap: 8px;">
                <button class="btn btn-outline-primary" @click="closeUnsavedModal">Cancel</button>
                <button class="btn btn-danger" @click="discardChanges" style="border: none;">Discard</button>
            </div>
        </v-card>
    </v-dialog>
</div>
